import { connect } from 'react-redux'
import Title from 'components/qa/Title'
import { handleExpandedTitleOnClick } from 'redux/actions'

const mapStateToProps = (state) => ({
  flavour: state.layout.flavour,
  expandedNodeTitle: state.accordion.expandedNodeTitle,
  sectionId: state.qa.sectionId,
  sectionsMap: state.qa.sectionsMap
})

const mapDispatchToProps = dispatch => ({
  handleExpandedTitleOnClick: () => dispatch(handleExpandedTitleOnClick())
})

export default connect(mapStateToProps, mapDispatchToProps)(Title)
